module.exports = __webpack_public_path__ + "components/rewards/support/static/logo-e77e19867961c7db6e7a2ec89dd6a093.jpg";